  <template>
  <div class="right">
    <div class="mainTop">
      <div class="underHeader">
        <img src="../../assets/img/info.png" alt />
        当前位置：
      </div>
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        style="width:50%;height: 54px;display: inline-block;line-height: 54px;"
      >
        <el-breadcrumb-item :to="{ path: '/' }">平台首页</el-breadcrumb-item>
        <el-breadcrumb-item>工业数据</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 切换 -->
    <div class="rightTab">
      <div class="tab" :class="{active:nowIndex==0}" @click="titleTab(0)">可视化概览</div>
      <div class="tab" :class="{active:nowIndex==1}" @click="titleTab(1)">数据列表</div>
    </div>
    <!-- 可视化 -->
    <Chart2 v-if="nowIndex===0" :initEchart='collapse'></Chart2>
    <!-- 数据列表 -->
    <DataList v-if="nowIndex===1" type="industrial"></DataList>
  </div>
</template>
<script>
import $ from "jquery";
import api from "@/../static/common/api/api.js";
window.api = api;
import magic from "@/../static/common/magic.js";
import axios from "axios";
import Chart2 from "@/components/chart2.vue";
import DataList from "@/components/dataList.vue";

export default {
  props: ['collapse'],
  components: {
    Chart2,
    DataList
  },
  data() {
    return {
      nowIndex: 0
    };
  },
  computed: {},
  methods: {
    firstShow() {
     let nowIndex1 = JSON.parse(sessionStorage.getItem("nowIndex"))?JSON.parse(sessionStorage.getItem("nowIndex")):0;
      this.nowIndex = nowIndex1;
    },
   
    // 切换
    titleTab(val) {
      this.nowIndex = val;
    }
  },
  created() {},
  mounted() {
    this.firstShow(); //首次展示
  }
};
</script>
<style scoped lang="less">
@import "../../assets/less/style.less";
@import "../../assets/less/right.less";
@import "../../assets/less/moreThanThree.less";
</style>


// WEBPACK FOOTER //
// src/view/industrial/rightPage.vue